// extracted by mini-css-extract-plugin
module.exports = {"wiggle":"DialogFinalizeSKP_wiggle__T1QCP"};